import { AccountVestingTypeEnum } from 'constants/vesting'
import { AccountVestingProviderV2 } from 'context/account-vesting-context-provider-v2'
import AccountVestingContentV2 from 'modules/account-vesting-v2/account-vesting-content-v2'

import './style.scss'

const AccountVestingVentureV2 = () => {
  return (
    <AccountVestingProviderV2 type={AccountVestingTypeEnum.ACCOUNT_VESTING_VENTURE_V2}>
      <AccountVestingContentV2 title="Account Vesting Venture V2" />
    </AccountVestingProviderV2>
  )
}

export default AccountVestingVentureV2
